export default __webpack_public_path__ + "static/media/Logo-Event.c4cbb49b.png";